/**
 * Chef Banchan Event System - ES5 Compatible
 * 이벤트 제품 감지 및 캘린더 필터링 시스템
 */

// Test Mode (테스트 시 주석 해제)
// window.ChefBanchanEventTestMode = {
//   enabled: true,
//   simulateEvents: {
//     thanksgiving: true,
//     kimchi: false
//   }
// };


// Event Configuration
window.ChefBanchanEvents = {
  newyear2026: {
  enabled: false,
  name: '새해세트',
  skus: ['0E5-0J0-00', '0E4-0IZ-00'], // 간단/한상
  dateRange: {
    start: '2025-12-26',
    end: '2025-12-31'
  },
  specialDeliveryRules: {
    LA_OC: {
      deliveryDays: {
        5: 'Direct delivery',  // 금 26
        6: 'FedEx',           // 토 27
        1: 'Direct delivery',  // 월 29
        2: 'Direct delivery',  // 화 30
        3: 'Direct delivery'   // 수 31 (원래 FedEx → 직접배송)
      }
    },
    SOCAL: {
      deliveryDays: {
        6: 'FedEx',  // 토 27
        2: 'FedEx',  // 화 30
        3: 'FedEx'   // 수 31
      }
    },
    NATIONWIDE: {
      deliveryDays: {
        2: 'FedEx',  // 화 30
        3: 'FedEx'   // 수 31
      }
    }
  },
  subtitle: {
    delivery: 'New Year set delivery: Dec 26-31 only'
  },
  badge: 'New Year',
  color: '#814E23',
  priority: 1
},

  Holiday2025: {
  enabled: false,
  name: 'Christmas set',
  skus: ['0E6-0J1-00'], 
  dateRange: {
    start: '2025-12-18',
    end: '2025-12-24'
  },
  specialDeliveryRules: {
    LA_OC: {
      deliveryDays: {
        4: 'Direct delivery',  // 목 18
        5: 'Direct delivery',  // 금 19
        6: 'FedEx',           // 토 20
        1: 'Direct delivery',  // 월 22
        2: 'Direct delivery',  // 화 23
        3: 'Direct delivery'   // 수 24 (원래 FedEx → 직접배송)
      }
    },
    SOCAL: {
      deliveryDays: {
        5: 'FedEx',  // 금 19
        6: 'FedEx',  // 토 20
        2: 'FedEx',  // 화 23
        3: 'FedEx'   // 수 24
      }
    },
    NATIONWIDE: {
      deliveryDays: {
        5: 'FedEx',  // 금 19
        2: 'FedEx',  // 화 23
        3: 'FedEx'   // 수 24
      }
    }
  },
  subtitle: {
    delivery: 'Christmas set delivery: Dec 18-24 only'
  },
  badge: 'Christmas',
  color: '#D11806',
  priority: 2
},
  
  thanksgiving2025: {
    enabled: false,
    name: '땡스기빙세트',
    skus: ['0DI-0IE-00'],
    dateRange: {
      start: '2025-11-20',
      end: '2025-11-26'
    },
    specialDeliveryRules: {
      LA_OC: {
        deliveryDays: {
          4: 'Direct delivery',  // 목 20
          5: 'Direct delivery',  // 금 21
          6: 'FedEx',           // 토 22
          1: 'Direct delivery',  // 월 24
          2: 'Direct delivery',  // 화 25
          3: 'Direct delivery'   // 수 26
        }
      },
      SOCAL: {
        deliveryDays: {
          5: 'FedEx',  // 금 21
          6: 'FedEx',  // 토 22
          2: 'FedEx',  // 화 25
          3: 'FedEx'   // 수 26
        }
      },
      NATIONWIDE: {
        deliveryDays: {
          5: 'FedEx',  // 금 21
          2: 'FedEx',  // 화 25
          3: 'FedEx'   // 수 26
        }
      }
    },
    subtitle: {
      delivery: 'Thanksgiving set - Delivery dates: Nov 20-26'
    },
    badge: 'Thanksgiving',
    color: '#FF8C00',
    priority: 1
  },
  
  kimchiPresale2025: {
    enabled: false,
    name: '김치 사전예약',
    skus: ['0DH-0IC-00'],
    dateRange: {
      start: '2025-11-17',
      end: '2025-12-31'
    },
    subtitle: {
      delivery: 'Pre-order Kimchi ships from Nov 17'
    },
    badge: '',
    color: '#808080',
    priority: 2
  }
};

// Event System IIFE
(function() {
  console.log('🎯 Event System Start');
  
  // ===================================
  // Core Functions
  // ===================================
  
  function getActiveEvents() {
    var events = window.ChefBanchanEvents || {};
    var activeEvents = [];
    
    for (var key in events) {
      if (events.hasOwnProperty(key) && events[key].enabled) {
        var event = events[key];
        event.id = key;
        activeEvents.push(event);
      }
    }
    
    return activeEvents;
  }
  
  function detectEventProducts() {
    // 테스트 모드
    if (window.ChefBanchanEventTestMode && window.ChefBanchanEventTestMode.enabled) {
      console.log('🧪 Test Mode Active');
      
      var activeEvents = getActiveEvents();
      var simulatedEvents = [];
      
      for (var i = 0; i < activeEvents.length; i++) {
        var event = activeEvents[i];
        
        if (event.id === 'thanksgiving2025' && window.ChefBanchanEventTestMode.simulateEvents.thanksgiving) {
          simulatedEvents.push({
            id: event.id,
            name: event.name,
            skus: event.skus,
            dateRange: event.dateRange,
            specialDeliveryRules: event.specialDeliveryRules,
            subtitle: event.subtitle,
            badge: event.badge,
            color: event.color,
            priority: event.priority,
            items: [{ title: '[Test] Thanksgiving Set', sku: event.skus[0] }]
          });
          console.log('✅ Thanksgiving Event Simulated');
        }
        
        if (event.id === 'kimchiPresale2025' && window.ChefBanchanEventTestMode.simulateEvents.kimchi) {
          simulatedEvents.push({
            id: event.id,
            name: event.name,
            skus: event.skus,
            dateRange: event.dateRange,
            subtitle: event.subtitle,
            badge: event.badge,
            color: event.color,
            priority: event.priority,
            items: [{ title: '[Test] Kimchi 5kg', sku: event.skus[0] }]
          });
          console.log('✅ Kimchi Event Simulated');
        }
      }
      
      simulatedEvents.sort(function(a, b) {
        return (a.priority || 999) - (b.priority || 999);
      });
      
      return Promise.resolve(simulatedEvents);
    }
    
    // 실제 장바구니 체크
    return fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var activeEvents = getActiveEvents();
        var detectedEvents = [];
        
        for (var i = 0; i < activeEvents.length; i++) {
          var event = activeEvents[i];
          var eventItems = [];
          
          for (var j = 0; j < cart.items.length; j++) {
            var item = cart.items[j];
            if (event.skus.indexOf(item.sku || '') !== -1) {
              eventItems.push(item);
            }
          }
          
          if (eventItems.length > 0) {
            event.items = eventItems;
            detectedEvents.push(event);
            console.log('✅ ' + event.name + ' Detected');
          }
        }
        
        detectedEvents.sort(function(a, b) {
          return (a.priority || 999) - (b.priority || 999);
        });
        
        return detectedEvents;
      })
      .catch(function(error) {
        console.error('❌ Cart Check Failed:', error);
        return [];
      });
  }
  
  function updateSubtitle(events) {
    var subtitle = document.getElementById('calendar-subtitle');
    if (!subtitle) return;
    
    // 📅 오늘 날짜 생성 (Nov 18 (Mon) 형식)
  var today = new Date();
  var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var dayNames = ['SUN','MOM','TUE','WED','THU','FRI','SAT'];
  var todayMonth = monthNames[today.getMonth()];
  var todayDate = today.getDate();
  var todayDay = dayNames[today.getDay()];
  var todayText = '[Today: ' + todayMonth + ' ' + todayDate + ' ' + todayDay + ']';
  
  if (events.length === 0) {
    subtitle.innerHTML = todayText + ' - 배송 받으실 날짜를 선택해주세요.';
    subtitle.style.color = '#808080';
    return;
  }
  
  var event = events[0];
  var message = event.subtitle.delivery || '배송 받으실 날짜를 선택해주세요.';
  
  // 🔥 Today 텍스트 + 이벤트 메시지
  subtitle.innerHTML = todayText + ' ' + message;
  subtitle.style.color = event.color;
  
  console.log('✅ Subtitle Updated: ' + event.name);
}
  
  function filterEventDates(events) {
    if (events.length === 0) {
      restoreAllDates();
      return;
    }
    
    var event = events[0];
    var startDate = new Date(event.dateRange.start);
    var endDate = new Date(event.dateRange.end);
    var dateOptions = document.querySelectorAll('.date-option');
    var validCount = 0;
    var hiddenCount = 0;
    
    var zipcodeEl = document.getElementById('current-zipcode');
    var zipcode = zipcodeEl ? zipcodeEl.textContent : '92831';
    var zone = 'LA_OC';
    
    if (window.ChefBanchan && window.ChefBanchan.ZipCodeManager) {
      zone = window.ChefBanchan.ZipCodeManager.getDeliveryZone(zipcode);
    }
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      var dateStr = option.dataset.date;
      if (!dateStr) continue;
      
      var optionDate = new Date(dateStr);
      var isInRange = optionDate >= startDate && optionDate <= endDate;
      
      if (event.specialDeliveryRules) {
        var dayOfWeek = optionDate.getDay();
        var zoneRules = event.specialDeliveryRules[zone];
        
        if (zoneRules && zoneRules.deliveryDays) {
          var deliveryMethod = zoneRules.deliveryDays[dayOfWeek];
          
          if (isInRange && deliveryMethod) {
            option.style.display = '';
            option.classList.remove('date-disabled');
            
            var methodEl = option.querySelector('.date-method');
            if (methodEl) {
              methodEl.textContent = deliveryMethod;
            }
            
            validCount++;
          } else {
            option.style.display = 'none';
            hiddenCount++;
          }
        }
      } else {
        if (optionDate >= startDate) {
          var wasVisible = option.style.display !== 'none' && !option.classList.contains('date-disabled');
          
          if (wasVisible) {
            option.style.display = '';
            option.classList.remove('date-disabled');
            validCount++;
          } else {
            option.style.display = 'none';
            hiddenCount++;
          }
        } else {
          option.style.display = 'none';
          hiddenCount++;
        }
      }
    }
    
    console.log('✅ ' + event.name + ' Date Filtering (' + zone + '): ' + validCount + ' shown, ' + hiddenCount + ' hidden');
  }
  
  function applyEventBadges(events) {
    var existingBadges = document.querySelectorAll('.event-badge');
    for (var i = 0; i < existingBadges.length; i++) {
      existingBadges[i].remove();
    }
    
    if (events.length === 0) return;
    
    var event = events[0];
    
    if (!event.badge) {
      console.log('ℹ️ ' + event.name + ': No badge');
      return;
    }
    
    var visibleDateOptions = document.querySelectorAll('.date-option:not([style*="display: none"]):not(.date-disabled)');
    var badgeCount = 0;
    
    for (var i = 0; i < visibleDateOptions.length; i++) {
      var option = visibleDateOptions[i];
      
      var badge = document.createElement('div');
      badge.className = 'event-badge';
      badge.style.cssText = 'font-size: 10px; color: ' + event.color + '; font-weight: bold; margin-top: 2px; line-height: 1;';
      badge.textContent = event.badge;
      
      option.appendChild(badge);
      badgeCount++;
      
      var originalClick = option.onclick;
      option.onclick = (function(opt, evt, origClick) {
        return function(e) {
          if (origClick) origClick.call(this, e);
          
          setTimeout(function() {
            opt.style.background = evt.color;
            opt.style.borderColor = evt.color;
            opt.style.color = 'white';
          }, 50);
        };
      })(option, event, originalClick);
    }
    
    console.log('✅ ' + event.name + ' Badges Added: ' + badgeCount);
  }
  
  function restoreAllDates() {
    console.log('🔄 Restoring all dates to normal');
    
    var dateOptions = document.querySelectorAll('.date-option');
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      option.style.display = '';
    }
    
    var badges = document.querySelectorAll('.event-badge');
    for (var i = 0; i < badges.length; i++) {
      badges[i].remove();
    }
    
    console.log('✅ Calendar Restored to normal');
  }
  
  function selectFirstAvailableDate() {
    console.log('🎯 Selecting first available date');
    
    var dateOptions = document.querySelectorAll('.date-option');
    var firstAvailable = null;
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      
      if (option.style.display !== 'none' && 
          !option.classList.contains('date-disabled')) {
        firstAvailable = option;
        break;
      }
    }
    
    if (firstAvailable) {
      console.log('✅ First available date found:', firstAvailable.dataset.date);
      
      var allOptions = document.querySelectorAll('.date-option');
      for (var i = 0; i < allOptions.length; i++) {
        allOptions[i].classList.remove('selected', 'date-selected');
        allOptions[i].style.background = '';
        allOptions[i].style.borderColor = '';
        allOptions[i].style.color = '';
      }
      
      firstAvailable.click();
      
    } else {
      console.warn('⚠️ No available date found');
    }
  }
  function showMultipleEventError() {
  var calendarContainer = document.getElementById('date-grid');
  var subtitle = document.getElementById('calendar-subtitle');
  
  if (calendarContainer) {
    calendarContainer.innerHTML = `
      <div style="width: 100%; padding: 12px 16px; text-align: center; background: #FFF4F1; border-radius: 8px;">
        
        <h3 style="color: #333; margin: 0px 0 4px 0; font-size: 18px; font-weight: 600;">
          크리스마스 & 새해 세트는 별도 주문이 필요합니다
        </h3>
        <p style="color: #999; margin: 0 0 12px 0; font-size: 13px; line-height: 1.3;">
          Holiday & New Year sets require separate orders
        </p>
        
        <p style="color: #666; margin: 0 0 4px 0; font-size: 16px; line-height: 1.5;">
          배송 기간이 달라 함께 주문하실 수 없습니다. 장바구니에서 하나를 제거해주세요.
        </p>
        <p style="color: #999; margin: 0 0 16px 0; font-size: 12px; line-height: 1.3;">
          Please remove one set from your cart to proceed
        </p>

        <div style="display: inline-flex; gap: 16px; font-size: 14px; color: #333;">
          <span>🎄 크리스마스: 12/18-24</span>
          <span>🎆 새해: 12/26-31</span>
        </div>
        
      </div>
    `;
  }
  
  if (subtitle) {
    subtitle.textContent = 'Please remove one set from cart to proceed';
    subtitle.style.color = '#856404';
  }
}
  


function processEventSystem() {
  console.log('🔄 Processing Event System...');
  
  var dateGrid = document.getElementById('date-grid');
  
  // 🔥 로딩 표시 먼저 보여주기
  // if (dateGrid) {
  //   dateGrid.innerHTML = '<div style="padding: 60px; text-align: center; color: #999;">Loading...</div>';
  //   dateGrid.style.opacity = '1';
  // }
  
  detectEventProducts().then(function(events) {
    console.log('📦 Detected Events:', events.length > 0 ? events.map(function(e) { return e.name; }).join(', ') : 'None');
    
    var hasChristmas = events.some(function(e) { return e.id === 'Holiday2025'; });
    var hasNewYear = events.some(function(e) { return e.id === 'newyear2026'; });
    
    if (hasChristmas && hasNewYear) {
      console.log('⚠️ Both sets detected!');
      showMultipleEventError();
      return;
    }
    
    updateSubtitle(events);
    
    var calendarDays = 14;
    
    if (events.length > 0) {
      var event = events[0];
      var today = new Date();
      var eventEnd = new Date(event.dateRange.end);
      var daysUntilEnd = Math.ceil((eventEnd - today) / (1000 * 60 * 60 * 24));
      
      calendarDays = Math.max(20, daysUntilEnd + 2);
      console.log('📅 Calendar Extended: ' + calendarDays + ' days');
    } else {
      console.log('📅 No events - Using default 14 days');
    }
    
    // 🔥 즉시 실행 (setTimeout 제거)
    if (typeof window.updateDeliveryCalendar === 'function') {
      var zipcode = document.getElementById('current-zipcode');
      var zip = zipcode ? zipcode.textContent : '92831';
      
      console.log('🔄 Updating calendar');
      window.updateDeliveryCalendar(zip, calendarDays);
      
      // 🔥 최소 지연만
      setTimeout(function() {
        if (events.length > 0) {
          console.log('🎯 Applying filters');
          filterEventDates(events);
          applyEventBadges(events);
          selectFirstAvailableDate();
        } else {
          console.log('🔄 Normal mode');
          restoreAllDates();
          selectFirstAvailableDate();
        }
      }, 100); // 🔥 200ms → 100ms
    }
  }).catch(function(error) {
    console.error('❌ Error:', error);
  });
}
  
function setupEventListeners() {
  console.log('🎧 Setting up event listeners');
  
  var debounceTimer = null;
  var isProcessing = false;
  var lastProcessTime = 0;
  var MIN_PROCESS_INTERVAL = 3000; // 🔥 3초로 늘림!
  
  function debouncedProcessEventSystem(delay) {
    delay = delay || 2000; // 🔥 2초로 늘림!
    
    var now = Date.now();
    if (now - lastProcessTime < MIN_PROCESS_INTERVAL) {
      // 🔥 로그도 제거 (너무 많아서)
      return;
    }
    
    if (isProcessing) {
      return;
    }
    
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    debounceTimer = setTimeout(function() {
      isProcessing = true;
      lastProcessTime = Date.now();
      console.log('🔄 Processing...');
      
      processEventSystem();
      
      setTimeout(function() {
        isProcessing = false;
      }, 2000);
    }, delay);
  }
      

  
  // 1. 클릭/터치
  var eventTypes = ['click', 'touchend'];
  for (var i = 0; i < eventTypes.length; i++) {
    document.addEventListener(eventTypes[i], function(e) {
      var target = e.target;
      
      var quantityButton = target.closest('.quantity__button') || 
                          target.closest('button[name="plus"]') || 
                          target.closest('button[name="minus"]');
      
      var removeButton = target.closest('cart-remove-button') || 
                        target.closest('.cart-item__remove');
      
      if (quantityButton || removeButton) {
        console.log('🛒 Cart button clicked');
        debouncedProcessEventSystem(2000); // 2초 딜레이
      }
    }, { passive: true });
  }
  
  // 2. Input 변경
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('quantity__input') || 
        e.target.name === 'updates[]') {
      console.log('🛒 Quantity changed');
      debouncedProcessEventSystem(1500);
    }
  });
  
  // 3. Shopify 이벤트
  var cartEventNames = ['cart:updated'];
  for (var i = 0; i < cartEventNames.length; i++) {
    document.addEventListener(cartEventNames[i], function(e) {
      console.log('🛒 Shopify event:', e.type);
      debouncedProcessEventSystem(1500);
    });
  }
  
  // 4. ZIP Code 변경
  window.addEventListener('chefBanchanZipCodeChanged', function() {
    console.log('📍 ZIP changed');
    debouncedProcessEventSystem(1000);
  });
  
  console.log('✅ Event listeners ready');
}
  
  // ===================================
  // Global Test Interface
  // ===================================
  
  window.eventSystemTest = {
    check: detectEventProducts,
    process: processEventSystem,
    restore: restoreAllDates,
    getActive: getActiveEvents,
    filter: filterEventDates,
    updateSubtitle: updateSubtitle,
    selectFirst: selectFirstAvailableDate
  };
  
  // ===================================
  // Initialize
  // ===================================
  
  function initialize() {
    console.log('🚀 Event System Initialize');
    var activeEvents = getActiveEvents();
    var names = activeEvents.map(function(e) { return e.name; }).join(', ');
    console.log('📋 Active Events: ' + names);
    
    function waitForEverything(attempts) {
      attempts = attempts || 0;
      
      var hasZipManager = window.ChefBanchan && window.ChefBanchan.ZipCodeManager;
      var dateGrid = document.getElementById('date-grid');
      var hasCalendar = dateGrid && dateGrid.children.length > 0;
      var hasUpdateFunction = typeof window.updateDeliveryCalendar === 'function';
      
      if (attempts === 0 || attempts % 10 === 0) {
        console.log('🔍 System Check (Attempt ' + attempts + '/100):');
        console.log('   ZIP Manager:', hasZipManager ? '✓' : '✗');
        console.log('   Calendar:', hasCalendar ? '✓' : '✗');
        console.log('   Update Function:', hasUpdateFunction ? '✓' : '✗');
      }
      
      if (hasZipManager && hasCalendar && hasUpdateFunction) {
        console.log('✅ All systems ready - Starting Event System');
        processEventSystem();
        setupEventListeners();
      } else if (attempts < 100) {
        setTimeout(function() {
          waitForEverything(attempts + 1);
        }, 200);
      } else {
        console.error('❌ Event System timeout after 20 seconds');
        console.error('Missing:', {
          zipManager: !hasZipManager,
          calendar: !hasCalendar,
          updateFunction: !hasUpdateFunction
        });
      }
    }
    
    waitForEverything(0);
  }
  
  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 500);
  }
  
})();